import BdcStockDay from "../components/Bdc/StockDay";

const BdcStockDayPage = () => <BdcStockDay />;

export default BdcStockDayPage;
